import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ENDPOINT } from 'services/configs/endpoint.constant';
import { DocumentService } from 'services/document/document.service';

interface UseTermsProps {
  tokenAvailable: boolean;
}

const useTerms = ({ tokenAvailable }: UseTermsProps) => {
  const [termsUrl, setTermsUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenTermsModal, setIsOpenTermsModal] = useState(false);

  const { i18n } = useTranslation();

  const onClose = () => {
    setIsOpenTermsModal(false);
  };

  useEffect(() => {
    if (tokenAvailable) {
      (async () => {
        const res = await DocumentService.getTermsOfServiceStatus();
        if (!res.user_accepted) {
          switch (i18n.language) {
            case 'ja':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_JA_LANGUAGE);
              break;
            case 'zh':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_ZH_LANGUAGE);
              break;
            case 'de':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_DE_LANGUAGE);
              break;
            case 'nl':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_NL_LANGUAGE);
              break;
            case 'es':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_ES_LANGUAGE);
              break;
            case 'fr':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_FR_LANGUAGE);
              break;
            case 'pt':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_PT_LANGUAGE);
              break;
            case 'ar':
              setTermsUrl(ENDPOINT.TERM_OF_SERVICE_AR_LANGUAGE);
              break;
            default:
              setTermsUrl(res.term_and_condition_url);
              break;
          }
          setIsOpenTermsModal(true);
        }
        setIsLoading(false);
      })();
    }
  }, [tokenAvailable, i18n.language]);

  return { isLoading, isOpenTermsModal, termsUrl, onClose };
};

export default useTerms;
